import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueSocketIO from 'vue-socket.io'
import 'typeface-roboto/index.css';
//import Filters from './filters'
import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed);
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import stockInit from 'highcharts/modules/stock'
import xrange from 'highcharts/modules/xrange'
import More from 'highcharts/highcharts-more'
import axios from "axios";
import statistics from './statistics'
import settings from './settings'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

// name is optional
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

import VueOffline from 'vue-offline'
Vue.use(VueOffline)
xrange(Highcharts)
More(Highcharts)
    //import More from 'highcharts/highcharts-more'
    //More(Highcharts)
stockInit(Highcharts)
Vue.use(HighchartsVue)

//import VueYoutube from 'vue-youtube'
//Vue.use(VueYoutube)

import vueVimeoPlayer from 'vue-vimeo-player'
Vue.use(vueVimeoPlayer)

//Vue.use(Filters)


Vue.prototype.$statistics = statistics
Vue.prototype.$settings = settings
Vue.prototype.$http = axios



import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease-in",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})



require('vue-flash-message/dist/vue-flash-message.min.css');
import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);

import AvatarCrop from 'vue-avatar-crop'
Vue.use(AvatarCrop)

import VuePictureSwipe from 'vue-picture-swipe';
Vue.component('vue-picture-swipe', VuePictureSwipe);

import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)



import './assets/css/css.css'
import 'typeface-roboto/index.css';


import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

Vue.config.productionTip = false


Vue.use(new VueSocketIO({
    debug: true,
    connection: 'https://tradeinpool.com:3001',

    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },

}))

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.loggedIn) {
            next({
                name: 'login',
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (store.getters.loggedIn) {
            next({
                name: 'app',
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

//Vue.prototype.$vueEventBus = new Vue(); // Global event bus


new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')